import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../../../config';
import { DictionaryConversionHistory } from '../../../../../types/dictionary';

// 辞書の変換履歴を新しい順に一覧取得する（再変換モーダルの「変換履歴」タブ用）。
// dictionaries/{id}/conversion_histories を created_at 降順で返す。
export const listDictionaryHistory = async (
  dictionaryId: string,
): Promise<DictionaryConversionHistory[]> => {
  const historiesRef = collection(db, 'dictionaries', dictionaryId, 'conversion_histories');
  const q = query(historiesRef, orderBy('created_at', 'desc'));
  const snapshot = await getDocs(q);

  return snapshot.docs.map(d => ({
    history_id: d.id,
    ...d.data(),
  })) as DictionaryConversionHistory[];
};
